export const getFieldType = (column = {}, tableConfig = {}) => {
  const fieldName = column?.Field;

  const typeRaw = column?.Type || "";
  const type = typeRaw.toLowerCase();

  // Static dropdown
  if (tableConfig?.fieldOptions?.[fieldName]) {
    return "select";
  }

  // Dependency dropdown
  if (tableConfig?.dependencies?.[fieldName]) {
    return "select";
  }

  if (
    type.includes("int") ||
    type.includes("decimal") ||
    type.includes("float") ||
    type.includes("double")
  ) {
    return "number";
  }

  if (
    type.includes("date") ||
    type.includes("timestamp") ||
    type.includes("datetime")
  ) {
    return "date";
  }

  if (
    type.includes("text") ||
    type.includes("longtext") ||
    type.includes("mediumtext")
  ) {
    return "textarea";
  }

  return "text";
};
